import React from 'react'

const ChatIcon = ({ color }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <g clipPath='url(#clip0_1817_5062)'>
        <path
          d='M19 3C19.7956 3 20.5587 3.31607 21.1213 3.87868C21.6839 4.44129 22 5.20435 22 6V16C22 16.7956 21.6839 17.5587 21.1213 18.1213C20.5587 18.6839 19.7956 19 19 19H7.333L4 21.5C3.176 22.118 2 21.53 2 20.5V6C2 5.20435 2.31607 4.44129 2.87868 3.87868C3.44129 3.31607 4.20435 3 5 3H19ZM19 5H5C4.73478 5 4.48043 5.10536 4.29289 5.29289C4.10536 5.48043 4 5.73478 4 6V19L6.133 17.4C6.47919 17.1404 6.90026 17 7.333 17H19C19.2652 17 19.5196 16.8946 19.7071 16.7071C19.8946 16.5196 20 16.2652 20 16V6C20 5.73478 19.8946 5.48043 19.7071 5.29289C19.5196 5.10536 19.2652 5 19 5ZM11 12C11.2549 12.0003 11.5 12.0979 11.6854 12.2728C11.8707 12.4478 11.9822 12.687 11.9972 12.9414C12.0121 13.1958 11.9293 13.4464 11.7657 13.6418C11.6021 13.8373 11.3701 13.9629 11.117 13.993L11 14H8C7.74512 13.9997 7.49997 13.9021 7.31463 13.7272C7.1293 13.5522 7.01777 13.313 7.00283 13.0586C6.98789 12.8042 7.07067 12.5536 7.23426 12.3582C7.39786 12.1627 7.6299 12.0371 7.883 12.007L8 12H11ZM16 8C16.2652 8 16.5196 8.10536 16.7071 8.29289C16.8946 8.48043 17 8.73478 17 9C17 9.26522 16.8946 9.51957 16.7071 9.70711C16.5196 9.89464 16.2652 10 16 10H8C7.73478 10 7.48043 9.89464 7.29289 9.70711C7.10536 9.51957 7 9.26522 7 9C7 8.73478 7.10536 8.48043 7.29289 8.29289C7.48043 8.10536 7.73478 8 8 8H16Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_1817_5062'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ChatIcon
